import { render, staticRenderFns } from "./topProducts.vue?vue&type=template&id=47418582&"
import script from "./topProducts.vue?vue&type=script&lang=js&"
export * from "./topProducts.vue?vue&type=script&lang=js&"
import style0 from "./topProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports